// libs
import React, { memo } from 'react';

//styles
import { AlphabetsContainer, Alphabet } from './styles';

//constants
import { ALPHABETS_ARRAY } from './constants';

// defs
interface IAlphabetStrip {
  setSelectedAlphabet: (text: string) => void;
  availableAlphabets: string[];
}

function AlphabetStrip({ setSelectedAlphabet, availableAlphabets }: IAlphabetStrip) {
  const onAlphabetSelection = (value: string) => {
    setSelectedAlphabet(value);

    const timer = window.setTimeout(() => {
      setSelectedAlphabet('');
      clearTimeout(timer);
    }, 1500);
  };

  return (
    <AlphabetsContainer>
      {ALPHABETS_ARRAY.map((alphabet) => {
        return (
          <Alphabet
            key={alphabet}
            onClick={() => onAlphabetSelection(alphabet)}
            isDisabled={!availableAlphabets.includes(alphabet)}
          >
            {alphabet}
          </Alphabet>
        );
      })}
    </AlphabetsContainer>
  );
}

export default memo(AlphabetStrip);
